// react
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Appt
import Box from '../../simple/box/Box'
import Layer from '../../simple/layer/Layer'
import Text from '../../simple/text/Text'

import ActionButton from '../actionButton/ActionButton'

/**
 * `NotificationLayer` renders a specific Layer
 */
function NotificationLayer(props) {
  const [open, setOpen] = useState(false)

  const onOpen = () => setOpen(true)

  const onClose = () => setOpen(false)

  const button1Click = () => {
    onClose()
    props.button1Click()
  }

  const button2Click = () => {
    onClose()
    props.button2Click()
  }

  useEffect(() => {
    onOpen()
  }, [])

  return (
    <>
      {open && (
        <Layer
          position={props.position}
          margin={{ vertical: 'medium', horizontal: 'small' }}
          onClickOutside={() => { onClose() }}
          onEsc={() => { onClose() }}
          responsive={false}
          plain
        >
          <Box
            align='center'
            direction='row'
            gap='small'
            justify='between'
            round='small'
            elevation='medium'
            pad={{ vertical: 'xsmall', horizontal: 'medium' }}
            background='light-2'
          >
            <Box width='medium' align='center' direction='row' gap='xsmall'>
              <Text >{props.children}</Text>

            </Box>

            <Box align='center' direction='row' gap='xsmall'>
              {props.button1Text &&
                // eslint-disable-next-line react/jsx-handler-names
                <ActionButton label={props.button1Text} onClick={() => { button1Click() }} primary />}
              {props.button2Text &&
                // eslint-disable-next-line react/jsx-handler-names
                <ActionButton label={props.button2Text} onClick={() => { button2Click() }} secondary />}
            </Box>
          </Box>
        </Layer>
      )}
    </>
  )
}

NotificationLayer.propTypes = {
  /**
   * Position of the Layer
   *
   * "bottom"
   * "bottom-left"
   * "bottom-right"
   * **"center"**
   * "end"
   * "hidden"
   * "left"
   * "right"
   * "start"
   * "top"
   * "top-left"
   * "top-right"

   */
  position: PropTypes.string,
  /**
   * Notification status - determines the colour of the layer
   *
   * "error"
   * **"ok"**
   * "warning"
   */
  status: PropTypes.string
}

export default NotificationLayer
